__turbopack_context__.v({
  "content": "Scroller-module__5nbjjG__content",
  "scrollerWrapper": "Scroller-module__5nbjjG__scrollerWrapper",
});
